import BigNumber from 'bignumber.js';
import { ActionCableService, distinctBigNumberUntilChanged, sharePublishReplay, swalloError } from 'ngx-libs';
import { combineLatest, of, timer } from 'rxjs';
import { debounceTime, map, startWith, switchMap } from 'rxjs/operators';
import { keepUpdater } from '../rxjs';
import { AccountService } from '../services/account.service';
import { ContractService } from '../services/contract.service';
import { EthWalletService } from '../services/eth-wallet.service';
import { MainService } from '../services/main.service';
import { Token } from './token';

export class ShareToken extends Token {
  constructor(
    public contract: string,
    public pool: string,
    public decimals: number,
    protected accountService: AccountService,
    protected ethWalletService: EthWalletService,
    protected contractService: ContractService,
    private actionCableService: ActionCableService,
    private mainService: MainService
  ) {
    super(contract, decimals, accountService, ethWalletService, contractService);

    const received = this.accountService.account.pipe(
      switchMap((a) => {
        if (a) {
          return this.actionCableService
            .received({
              channel: 'TokenBalanceChannel',
              token: this.contract,
              account: a.toLocaleLowerCase()
            })
            .pipe(startWith(0), debounceTime(10));
        } else {
          return of(0);
        }
      })
    );

    const source = combineLatest([this.accountService.account, received, timer(0, 60000)]).pipe(sharePublishReplay(1));
    // this.balance = source.pipe(
    //   debounceTime(20),
    //   keepUpdater(),
    //   switchMap(([a]) =>
    //     a
    //       ? this.mainService.accounts.of(a.toLocaleLowerCase()).tokenBalances.get(this.contract).pipe(swalloError())
    //       : of({ tokenBalance: { amount: new BigNumber(0) } })
    //   ),
    //   map((json) => json.tokenBalance.amount),
    //   distinctBigNumberUntilChanged(),
    //   sharePublishReplay(1)
    // );
    this.balance = source.pipe(
      debounceTime(20),
      switchMap(([a]) =>
        a
          ? this.mainService.accounts.of(a.toLocaleLowerCase()).tokenBalances.get(this.contract).pipe(swalloError())
          : of({ tokenBalance: { amount: new BigNumber(0) } })
      ),
      map((json) => json.tokenBalance.amount),
      distinctBigNumberUntilChanged(),
      sharePublishReplay(1)
    );
  }
}
